<!-- TODO Mobile Responsive-->
<p class="finzy-row">{{getOverDueEmiCount()}} successive EMIs for this loan has remained overdue and unpaid.
    As a result, this loan has been classified as {{getDisplayableStatus()}}.
    <span *ngIf="isSubStandardAsset()">
    If the loan remains as Sub Standard Asset for another 12 months,the loan will be classified as Loss Asset.
</span>
    Please note the classification of loans and treatment below.</p>
<div class="d-flex flex-container">
    <div class="p-2">
        <p class="finzy-header-1">INVESTMENT DATE</p>
        <p class="finzy-header-2">{{investmentDate | dateFormat}}</p>
    </div>
    <div class="p-2">
        <p class="finzy-header-1">MATURITY DATE</p>
        <p class="finzy-header-2">{{maturityDate | dateFormat}}</p>
    </div>
    <div class="p-2">
        <p class="finzy-header-1">EMI AMOUNT</p>
        <p class="finzy-header-2">{{emiAmount | indianCurrency}}</p>
    </div>
    <div class="p-2">
        <p class="finzy-header-1">EMI COUNT RECEIVED</p>
        <p class="finzy-header-2">{{paidEmiCount}}</p>
    </div>
    <div class="p-2">
        <p class="finzy-header-1">DELAYED EMI'S</p>
        <p class="finzy-header-2">{{delayedEmiCount}}</p>
    </div>
</div>
<p class="finzy-row">Please note the classification of loans and treatment below.</p>
<table class="table finzy-datatable table-responsive">
    <thead class="table-header">
    <tr>
        <th style="width: 25%">Overdue EMI Count</th>
        <th style="width: 25%">Loan Classification</th>
        <th style="width: 25%">Interest Accrual</th>
        <th style="width: 25%">Principal Outstanding</th>
    </tr>
    </thead>

    <tbody>
    <tr class="tr-row">
        <td>Upto 3 EMIs</td>
        <td>Delayed Loan</td>
        <td>Interest continues to accrue</td>
        <td>No impact</td>
    </tr>

    <tr class="tr-row">
        <td>Between 4 to 12 EMIs</td>
        <td>Non performing Asset (NPA)</td>
        <td>Interest continues to accrue</td>
        <td>No impact</td>
    </tr>

    <tr class="tr-row" [ngClass]="{'tr-row-highlight': isSubStandardAsset()}">
        <td>Between 13 to 24 EMIs (Current Loan Classification)</td>
        <td>Sub Standard Asset (SSA)</td>
        <td>Accrued interest is written-off. No further accrual of interest</td>
        <td>50% principal outstanding is written-off</td>
    </tr>

    <tr class="tr-row" [ngClass]="{'tr-row-highlight': !isSubStandardAsset()}">
        <td>25 EMIs</td>
        <td>Loss Asset (LA)</td>
        <td>No interest accrual</td>
        <td>Remaining 50% principal outstanding is written-off</td>
    </tr>
    </tbody>
</table>
<p class="finzy-row">Our collection team will actively continue its efforts to recover outstanding
    amount from this loan. In case any amount is recovered from the loan,
    it will be distributed proportionately to all the lenders of this loan.</p>

<div class="d-flex flex-column font-weight-bold">
    <div class="d-flex flex-row">
        <div class="mr-auto p-4">Investment amount <span class="small-text font-color-grey">(A)</span></div>
        <div class="p-4">{{investedAmount | currency:'INR': 'symbol': '1.2-2': 'en-IN'}}</div>
    </div>
    <div class="d-flex flex-row">
        <div class="mr-auto p-4">Principal paid back through EMI’s <span class="small-text font-color-grey">(B)</span>
        </div>
        <div class="p-4">{{emiSplit?.principal | indianCurrency}}</div>
    </div>
    <div class="d-flex flex-row">
        <div class="mr-auto p-4">Principal paid back through prepayments <span
                class="small-text font-color-grey">(C)</span></div>
        <div class="p-4">{{prepaymentSplit?.principal| indianCurrency}}</div>
    </div>
    <div class="d-flex flex-row">
        <div class="mr-auto p-4">Capitalised interest accrued due to moratorium <span
                class="small-text font-color-grey">(D)</span></div>
        <div class="p-4">{{capitalisedInterest| indianCurrency}}</div>
    </div>
    <div class="d-flex flex-row">
        <div class="mr-auto p-4">Principal outstanding<span
                class="small-text font-color-grey">[(E) = (A) - (B) - (C) + (D)]</span>
        </div>
        <div class="p-4">{{principalOutstanding | indianCurrency}}</div>
    </div>
    <div class="d-flex flex-row">
        <div class="mr-auto p-4">Net interest earned till date (post 2% finzy fees and 18% GST on the fees) <span
                class="small-text font-color-grey">(F)</span></div>
        <div class="p-4">{{netInterestEarned | indianCurrency}}</div>
    </div>
</div>
<div class="d-flex flex-column mt-3 font-weight-bold"
     [ngStyle]="{'background-color': isSubStandardAsset() ? '#f1f3f8': ''}">
    <div class="d-flex flex-row" [ngStyle]="{'color': isSubStandardAsset() ? '#0d3ab3': ''}">
        <div class="mr-auto p-4">Loan classified as Sub Standard Asset on</div>
        <div class="p-4">{{subStandardDate | dateFormat}}</div>
    </div>
    <div class="d-flex flex-row">
        <div class="mr-auto p-4">Percentage of principal written-off (at point of Sub Standard asset classification)
        </div>
        <div class="p-4">{{percentageOfSubStandardAssetPrincipalWrittenOff}}%</div>
    </div>
    <div class="d-flex flex-row">
        <div class="mr-auto p-4">Principal amount written-off (at point of Sub Standard asset classification)<span
                class="small-text font-color-grey">(G)</span></div>
        <div class="p-4"> {{subStandardAssetPrincipalWrittenOff | indianCurrency}}</div>
    </div>
    <div class="d-flex flex-row">
        <div class="mr-auto p-4">Current net realised loss
            <span class="small-text font-color-grey">[(H) = (G)-(F)]</span></div>
        <div class="p-4"> {{currentNetLoss | indianCurrency}}</div>
    </div>
</div>
<div class="d-flex flex-column mt-3 font-weight-bold"
     [ngStyle]="{'background-color': !isSubStandardAsset() ? '#f1f3f8': ''}">
    <div class="d-flex flex-row" [ngStyle]="{'color': !isSubStandardAsset() ? '#0d3ab3': ''}">
        <div class="mr-auto p-4">Loan may be classified as Loss Asset on</div>
        <div class="p-4">{{expectedLossAssetDate | dateFormat}}</div>
    </div>

    <div class="d-flex flex-row">
        <div class="mr-auto p-4">{{isSubStandardAsset() ? "Percentage of principal to be written-off, if classified as loss asset" : "Percentage of principal written-off"}}</div>
        <div class="p-4">{{isSubStandardAsset() ? percentageOfLossAssetPrincipalWrittenOff : "Remaining " + percentageOfLossAssetPrincipalWrittenOff}}%
        </div>
    </div>
    <div class="d-flex flex-row">
        <div class="mr-auto p-4">{{isSubStandardAsset() ? "Principal amount to be written-off, if classified as loss asset" : "Principal amount written-off"}}
            <span class="small-text font-color-grey">[(I) = (E)-(G)]</span></div>
        <div class="p-4">{{lossAssetPrincipalWrittenOff | indianCurrency}}</div>
    </div>
    <div class="d-flex flex-row font-weight-bolder">
        <div class="mr-auto p-4">{{isSubStandardAsset() ? "Total net expected loss" : "Total net realised loss at the point of Loss Asset classification"}}
            <span
                    class="small-text font-color-grey">[(J) = (E)-(F)]</span></div>
        <div class="p-4">{{expectedLoss | indianCurrency}}</div>
    </div>

</div>
